// 初期表示
export const PAGE_INIT = "sample/PAGE_INIT";
